export const store = {
    title: "สาขาทั้งหมด",
    bangkok: "กรุงเทพฯ",
    provincial: 'ต่างจังหวัด',
    airport: 'สนามบิน',
    nearby: 'ใกล้ฉัน',

    km: 'km.',
    get_direction: 'ขอเส้นทาง',
    tel: 'โทร :',
    call_now: 'โทร',
    service: 'บริการ'
};